/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation DownloadDocumentsSub4Mutation($input: DownloadDocuments_M_souscription_recapInput!) {
    downloadDocumentsSub4_M_souscription_recap(input: $input) {
      ok
      error
      
        urls 
    }
  }
`;

export default mutation;
